<div
    id="constructionToolsDiv"
    style="height:0;overflow:visible">
    @if (isVisible()) {
        <div
            id="constructionTools"
            class="widget container-fluid well"
            cdkDrag
            [cdkDragConstrainPosition]="computeDragPosition">
            <form
                id="constructionToolsForm"
                name="form"
                novalidate
                autocomplete="off"
                #constructionToolsForm="ngForm">
                <div
                    class="col-xs-12 widget-header"
                    cdkDragHandle>
                    <span>{{widgetConfig.header}}</span>
                    <div class="pull-right btn-group btn-group-xs">
                        <nlrp-help-link
                            [url]="getHelpUrl()"
                            [pageTitle]="getHelpPageTitle()"></nlrp-help-link>
                        @if (!windowMode) {
                            <i
                                class="nlrp-icon nlrp-icon-dock-out nlrp-18"
                                title="Open on new window"
                                (click)="openWidgetWindow();">
                            </i>
                        }
                        @if (windowMode) {
                            <i
                                class="nlrp-icon nlrp-icon-dock-in nlrp-18"
                                title="Reset widget to default mode"
                                (click)="closeWidgetWindow(true);">
                            </i>
                        }
                        @if (!windowMode) {
                            <i
                                [title]="open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip"
                                class="nlrp-icon nlrp-18"
                                [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                                (click)="showOrHideWidgetContent()">
                            </i>
                        }
                        @if (!windowMode) {
                            <i
                                id="constructionToolCloseBtn"
                                class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                                [title]="widgetConfig.closeTooltip"
                                (click)="closeWidget()"></i>
                        }
                    </div>
                </div>
                <div
                    [hidden]="!open"
                    class="widget-content">
                    <div class="mgt10">
                        <div class="col-xs-12">
                            <!-- Nav tabs -->
                            @for (toolRow of toolRows; track toolRow) {
                                <ul
                                    class="nav nav-tabs"
                                    role="tablist">
                                    @for (tool of toolRow.tools; track trackByToolId($index, tool)) {
                                        @if (tool.isVisible && (tool.permissions | hasPermissions)) {
                                            <li role="presentation">
                                                <a
                                                    aria-controls="{{tool.type}}ConstructionToolTab"
                                                    role="tab"
                                                    data-toggle="tab"
                                                    class="icon-tab">
                                                    <button
                                                        type="button"
                                                        class="btn btn-default nlr-icon-btn"
                                                        id="{{tool.type}}ConstructionTool"
                                                        [title]="tool.tooltip"
                                                        [ngClass]="{active: getSelectedToolId() === tool.id}"
                                                        (click)="changeSelectedConstructionTool(tool)"
                                                        [disabled]="isToolDisabled(tool)">
                                                        <i class="nlrp-icon {{tool.icon}}"></i>
                                                    </button>
                                                </a>
                                            </li>
                                        }
                                    }
                                </ul>
                            }
                            <!-- Tab panes -->
                            <div class="tab-content">
                                <li
                                    role="presentation"
                                    class="divider"></li>
                                @for (toolRow of toolRows; track toolRow) {
                                    <div>
                                        @for (tool of toolRow.tools; track tool) {
                                            @if (getSelectedToolId() === tool.id) {
                                                <construction-tool
                                                    id="{{tool.type}}ConstructionToolTab"
                                                    role="tabpanel"
                                                    class="tab-pane"
                                                    [ngClass]="{active: getSelectedToolId() === tool.id}"
                                                    [tool]="tool"
                                                    [toolsId]="id">
                                                </construction-tool>
                                            }
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 inline-bottom-buttons">
                    @if (getSelectedToolPermissions() | hasPermissions) {
                        <button
                            [id]="getCreateButtonId()"
                            class="btn btn-default create"
                            [ngClass]="{active : isCreateActive() && !getFinishButtonLabel()}"
                            [disabled]="createIsDisabled() || isButtonBlocked() || (getSelectedToolPermissions() | disabledByPermissions)"
                            (click)="create()">
                            {{getCreateButtonLabel()}}
                        </button>
                    }
                    @if (getFeatureButtonLabel() && (getSelectedToolPermissions() | hasPermissions)) {
                        <button
                            id="applyFeatureBtn"
                            class="btn btn-default"
                            [disabled]="applyFeatureActionIsDisabled() || isButtonBlocked()|| (getSelectedToolPermissions() | disabledByPermissions)"
                            (click)="applyFeatureAction()">
                            {{getFeatureButtonLabel()}}
                        </button>
                    }
                    @if (getClearButtonLabel() && (getSelectedToolPermissions() | hasPermissions)) {
                        <button
                            id="clearBtn"
                            class="btn btn-default clear"
                            [disabled]="clearIsDisabled() || isButtonBlocked() || (getSelectedToolPermissions() | disabledByPermissions)"
                            (click)="clear(true)">
                            {{getClearButtonLabel()}}
                        </button>
                    }
                    <button
                        id="closeBtn"
                        class="btn btn-default cancel"
                        (click)="closeWidget()">
                        {{getCloseButtonLabel()}}
                    </button>
                </div>
            </form>
        </div>
    }
</div>
